import { forEach } from 'lodash'


const testInitialState = (state) => {
  const { misc: { vindiciaUrl } } = state
  const errors = []

  if (!vindiciaUrl || !/http/.test(vindiciaUrl)) {
    errors.push('wrong misc.vindiciaUrl value')
  }

  forEach(errors, (error) => {
    // block warning in unit tests
    if (process.env.UNIT_TESTS !== 'true') {
      console.error(`InitialState error: ${error}`)
    }
  })
}

export default testInitialState
